/* @flow */
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import React from 'react';

import cx from 'classnames';
import './styles/DividerText.scss';

class DividerText extends React.Component {
  static propTypes = {
    text: React.PropTypes.string,
    color: React.PropTypes.oneOf(['violet', 'grey']),
    weight: React.PropTypes.oneOf(['thin', 'thick']),
    uppercase: React.PropTypes.bool,
    dividerPosition: React.PropTypes.oneOf(['top', 'middle', 'bottom']),
  };

  static propClasses = {
    color: {
      violet: 'DividerText-violet',
      grey: 'DividerText-grey',
    },
    weight: {
      thin: 'DividerText-thin',
      thick: 'DividerText-thick',
    },
    uppercase: 'DividerText-uppercase',
    dividerPosition: {
      top: 'DividerText-top',
      middle: 'DividerText-middle',
      bottom: 'DividerText-bottom',
    },
  };

  static defaultProps = {
    color: 'grey',
    weight: 'thin',
    uppercase: false,
    dividerPosition: 'middle',
  };

  renderText = () => {
    const { text } = this.props;
    if (!text) {
      return null;
    }
    return <span className="DividerText-text">{text}</span>;
  };

  render() {
    return (
      <div className={cx('DividerText', getPropClassesFromInstance(this), this.props.className)}>
        {this.renderText()}
      </div>
    );
  }
}

export default DividerText;



// WEBPACK FOOTER //
// ./src/components/DividerText.jsx